import { useWalletsMe } from '@/api/wallets';
import { ModalsKey } from '@/enums/modalsKey';
import { RootState } from '@/lib/store';
import { BetStatusId } from '@/models/bet/status/id';
import { DetailedBet } from '@/models/detailed-bet';
import { AudioService } from '@/services/AudioService';
import { AuthService } from '@/services/AuthService';
import { getMoneyOrAmount } from '@/utils/account/getMoneyOrAmount';
import { Nullable } from '@starsoft/common/interfaces';
import { useSelector } from 'react-redux';
import { useModalNavigation } from '../modals/useModalNavigation';

export function useGameButton() {
  const isServer: boolean = typeof window === 'undefined';
  const { navigateToModal } = useModalNavigation();
  const amount: number = useSelector(
    (state: RootState) => state.gamePreferences.amount,
  );
  const { wallet } = useWalletsMe({
    refetchOnMount: false,
  });
  const unavailableBalance: boolean =
    +amount > Number(getMoneyOrAmount(wallet?.currentAccount?.balance));

  function getIsError(): boolean {
    if (!wallet || isServer) {
      return false;
    }

    const castedAmount = +amount;
    const coin = wallet?.currentAccount?.coin;

    if (coin && castedAmount < getMoneyOrAmount(coin?.minimumBetAmount)) {
      return true;
    }

    return false;
  }

  const isError: boolean = getIsError();

  function onClick(bet: Nullable<DetailedBet>, callback: VoidFunction) {
    if (!AuthService.isAuthorized()) {
      navigateToModal(ModalsKey.Login);
      return;
    } else if (
      unavailableBalance &&
      bet?.status?.status?.id?.toString() != BetStatusId.Open?.toString()
    ) {
      navigateToModal(ModalsKey.UnavailableBalance);
      return;
    }

    AudioService.gameButtonTick();
    callback();
  }

  return {
    isError,
    onClick,
  };
}
